import React from 'react';


const ContentPageSkeleton: React.FC = () => {
    return (
      <div className="max-w-6xl mx-auto animate-pulse">
        {/* Breadcrumb fake */}
        <div className="mb-6 flex items-center gap-2">
          <div className="h-4 w-16 bg-gray-200 rounded"></div>
          <div className="h-4 w-4 bg-gray-200 rounded"></div>
          <div className="h-4 w-24 bg-gray-200 rounded"></div>
        </div>

        {/* Título fake */}
        <div className="mb-6">
          <div className="h-8 w-1/3 bg-gray-200 rounded mb-4"></div>
          <div className="h-10 w-48 bg-gray-200 rounded"></div>
        </div>

        {/* Player + lista fake */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 h-72 bg-gray-200 rounded-xl"></div>
          <div className="space-y-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="h-20 bg-gray-200 rounded-lg"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

export default ContentPageSkeleton;
